import {
  CandidateActionStatus,
  CandidatesListParams,
} from 'features/Principal/types/candidatesListTypes';
import { BaseNimbleAPI } from './baseAPI';

class PrincipalAPI extends BaseNimbleAPI {
  get config() {
    return { baseURL: '/api/principals/' };
  }

  async getCandidatesList({ school_id, page, ordering }: CandidatesListParams) {
    const params: CandidatesListParams = { school_id };
    if (page !== undefined) params.page = page;
    if (ordering) params.ordering = ordering;

    const response = await this.get('candidates/', { params });
    return response.data;
  }

  async updateCandidateStage(applicationId: number, stage: CandidateActionStatus) {
    const response = await this.put(`candidates/${applicationId}/stage/`, { stage });
    return response.data;
  }
}

export default new PrincipalAPI();
